"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getStaffAvailability = getStaffAvailability;
exports.getStaffDetail = getStaffDetail;
exports.removeFavorite = removeFavorite;
exports.addFavorite = addFavorite;
exports.changeAvailability = changeAvailability;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _utils = require("../utils");

var _internals = require("../utils/internals");

function getStaffAvailability(_x) {
  return _getStaffAvailability.apply(this, arguments);
}

function _getStaffAvailability() {
  _getStaffAvailability = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(contactId) {
    return _regenerator.default.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context;

              return (0, _concat.default)(_context = "".concat(base, "/v1/staff-availability")).call(_context, contactId ? "/".concat(contactId) : '');
            }).then( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
                return _regenerator.default.wrap(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x6) {
                return _ref.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(response) {
                return _regenerator.default.wrap(function _callee2$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x7) {
                return _ref2.apply(this, arguments);
              };
            }()).then(function (body) {
              return body.staffAvailability;
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _getStaffAvailability.apply(this, arguments);
}

function getStaffDetail(_x2) {
  return _getStaffDetail.apply(this, arguments);
}

function _getStaffDetail() {
  _getStaffDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(contactId) {
    return _regenerator.default.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", getStaffAvailability(contactId).then(function (list) {
              return list[0];
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));
  return _getStaffDetail.apply(this, arguments);
}

function removeFavorite(_x3) {
  return _removeFavorite.apply(this, arguments);
}

function _removeFavorite() {
  _removeFavorite = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(contactId) {
    return _regenerator.default.wrap(function _callee6$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context6;

              return (0, _concat.default)(_context6 = "".concat(base, "/v1/staff-availability/favorites/")).call(_context6, contactId);
            }).then( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(url) {
                return _regenerator.default.wrap(function _callee5$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        return _context7.abrupt("return", fetch(url, {
                          method: 'DELETE',
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x8) {
                return _ref3.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee6);
  }));
  return _removeFavorite.apply(this, arguments);
}

function addFavorite(_x4) {
  return _addFavorite.apply(this, arguments);
}

function _addFavorite() {
  _addFavorite = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(contactId) {
    return _regenerator.default.wrap(function _callee8$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context9;

              return (0, _concat.default)(_context9 = "".concat(base, "/v1/staff-availability/favorites/")).call(_context9, contactId);
            }).then( /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url) {
                return _regenerator.default.wrap(function _callee7$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        return _context10.abrupt("return", fetch(url, {
                          method: 'PUT',
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x9) {
                return _ref4.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee8);
  }));
  return _addFavorite.apply(this, arguments);
}

function changeAvailability(_x5) {
  return _changeAvailability.apply(this, arguments);
}

function _changeAvailability() {
  _changeAvailability = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(options) {
    return _regenerator.default.wrap(function _callee10$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              return "".concat(base, "/v1/staff-availability");
            }).then( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(url) {
                return _regenerator.default.wrap(function _callee9$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        return _context12.abrupt("return", fetch(url, {
                          method: 'PUT',
                          body: (0, _stringify.default)(options),
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee9);
              }));

              return function (_x10) {
                return _ref5.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee10);
  }));
  return _changeAvailability.apply(this, arguments);
}
